export interface StorageService {
  retrieve(key: string): any;
  store(key: string, value: any): void;
}

abstract class BaseStorageService implements StorageService {
  constructor(private storage: Storage) {
  }

  public retrieve(key: string): any {
    const item = this.storage.getItem(key);

    if (item && item !== 'undefined') {
        return JSON.parse(item)
    }

    return null
  }

  public store(key: string, value: any): void {
      this.storage.setItem(key, JSON.stringify(value))
  }
}

export enum StorageType {
  Local = 1,
  Session
}

export class LocalStorageService extends BaseStorageService {
  constructor() {
    super(localStorage)
  }

}

export class SessionStorageService extends BaseStorageService {
  constructor() {
    super(sessionStorage)
  }
}
